export default __webpack_public_path__ + "static/media/plus.d248aa42.svg";